<div class="wrapper">
  <h3>{{ name | translate }}</h3>
  <ix-cpu-chart-gauge></ix-cpu-chart-gauge>
</div>
